export default __webpack_public_path__ + "static/ab-devices-a3f1a9ed1564c01a58edf83dbcca6b40.jpg";